import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';

export interface IAppState {
  sidebar: {
    opened: boolean;
  };
  config: SnackbarConfig;
  orderState: string;
  globalMask: boolean;
}

interface SnackbarConfig {
  show: boolean;
  color: string;
  mode: string;
  timeout: number;
  text: string;
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
  public sidebar = {
    opened: true
  };
  public orderState = ''; //orderlist state
  public globalMask = false;
  public config: SnackbarConfig = {
    show: false,
    color: 'error',
    mode: '1',
    timeout: 2000,
    text: ''
  };

  @Action({ commit: 'TOGGLE_SIDEBAR' })
  public ToggleSideBar() {
    return;
  }

  @Action({ commit: 'SET_GLOBALMASK' })
  public SetMask(mask: boolean) {
    return mask;
  }

  @Mutation
  private TOGGLE_SIDEBAR() {
    this.sidebar.opened = !this.sidebar.opened;
  }

  @Mutation
  private SET_GLOBALMASK(msk: boolean) {
    this.globalMask = msk;
  }

  /**弹出成功提示 */
  @Action({ commit: 'Show_Snackbar' })
  public async ShowSuccess(text: string) {
    return {
      show: true,
      color: 'success',
      mode: '',
      timeout: 2000,
      text: text
    };
  }
  /**弹出信息提示 */
  @Action({ commit: 'Show_Snackbar' })
  public async ShowInfo(text: string) {
    return {
      show: true,
      color: '#1abc9c', //'cyan darken-2',
      mode: '',
      timeout: 2000,
      text: text
    };
  }
  @Action({ commit: 'Show_Snackbar' })
  public async ShowWarning(text: string, time: number) {
    return {
      show: true,
      color: 'warning',
      mode: '',
      timeout: time,
      text: text
    };
  }
  /**弹出错误提示 */
  @Action({ commit: 'Show_Snackbar' })
  public async ShowError(text: string) {
    return {
      show: true,
      color: 'error',
      mode: '',
      timeout: 2000,
      text: text
    };
  }

  @Mutation
  private Show_Snackbar(snackbarConfig: SnackbarConfig) {
    this.config = snackbarConfig;
  }

  @Mutation
  Update_OrderState(data: string) {
    this.orderState = data;
  }
}

export const AppStore = getModule(App);
